<div *ngIf="this.aciPaymentService.showLoader" class="loader"> </div>
<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12 payment-process">
          <h3 class="text-black">Payment Processing</h3>
            <p class="text-black">Do you want to continue to make this payment?</p> 
            <div class="action-btns">
                <button type="button" class="btn ac-btn-outline-primary ac-butncancel mr-3" data-dismiss="modal" (click)="close()">
                    Cancel
                </button>           
                <button type="button" class="btn ac-btn-primary mb-sm-0" (click)="pay()" [disabled]="this.aciPaymentService.showLoader">
                    Make Payment
                </button>
            </div>
            <div class="terms-and-conditions">
                <a href="https://www.speedpay.com/terms/" target="_blank">View Terms & Conditions</a>
            </div>
        </div>
    </div>
</div>